import apiClient from '@/services/axios'

export async function get(venueId) {
  var params = { 'venue-details-id': venueId}

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/rejected-requests', params);

  if (response) {
    return response.data;
  }

  throw new Error('Unable to get rejected requests.')
}
